import { frontendURL } from 'dashboard/helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/business-connectors'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'business_connectors_settings',
          meta: { permissions: ['administrator'] },
          component: Index,
        },
      ],
    },
  ],
};
